/**
 * @description
 */

import Api from '../../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IInput {
    resource_id: number;
}

export interface IOutput {
    resource_id: number;
}

export const pptToImgCancel = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PPT_TO_IMG_CANCEL, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const pptToImgCancelSync = fetchDataSync<IInput>(pptToImgCancel);
